import { PureComponent } from 'react';
import CSSModules from 'react-css-modules';
import PropTypes from 'prop-types';
import { Alert, AnchorLink, ButtonLoading, Icon } from 'platfi-ui-components';

import { Form } from 'informed';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { FundingEnquiryStatus } from 'enums/funding-enquiry-status';

import withModal from 'HOC/withModal';

import {
  makeSelectUpdateStatusError,
  makeSelectUpdateStatusLoading,
} from 'reducers/fundingEnquiry/selectors';
import * as fundingEnquiryActions from 'reducers/fundingEnquiry/reducer';

import styles from './styles.scss';

@CSSModules(styles)
class UpdateEnquiryStatusModal extends PureComponent {
  static propTypes = {
    closeModal: PropTypes.func.isRequired,
    error: PropTypes.bool,
    loading: PropTypes.bool,
    modalState: PropTypes.instanceOf(Map),
    updateFundingEnquiryStatus: PropTypes.func.isRequired,
  };

  onSubmit = () => {
    const { closeModal, modalState, updateFundingEnquiryStatus } = this.props;

    updateFundingEnquiryStatus(
      modalState?.getIn(['props', 'id']),
      modalState?.getIn(['props', 'type']),
    ).then(closeModal);
  };

  render() {
    const { closeModal, error, loading, modalState } = this.props;

    const cancel = modalState?.getIn(['props', 'type']) === FundingEnquiryStatus.cancelled;
    const action = cancel ? 'Close' : 'Complete';

    return (
      <div className="o-modal-form o-container-xxxs u-align-center">
        {error && (
          <Alert className="o-modal-form__alert" error label="We couldn’t submit your request" />
        )}

        <div className={`o-modal__icon o-modal__icon--${cancel ? 'cancel' : 'success'}`}>
          <Icon className="a-svg-xxxlarge" icon={`round_outlined_${cancel ? 'cancel' : 'check'}`} />
        </div>

        <h1 className="o-modal__title">{action} funding enquiry</h1>

        <p className="o-modal__text">
          Are you sure you want to {action.toLowerCase()} this funding enquiry?
        </p>

        <Form onSubmit={this.onSubmit}>
          <div className="o-modal__actions">
            <div className="o-modal__actions__action">
              <ButtonLoading
                cancel={cancel}
                className="o-modal__actions__action"
                label={`${action} funding enquiry`}
                loading={loading}
                primary={!cancel}
                type="submit"
              />
            </div>

            <div className="o-modal__actions__action">
              <AnchorLink onClick={closeModal} secondary underlined>
                Return to Funding Enquiries
              </AnchorLink>
            </div>
          </div>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  error: makeSelectUpdateStatusError(),
  loading: makeSelectUpdateStatusLoading(),
});

const mapDispatchToProps = (dispatch) => ({
  updateFundingEnquiryStatus: (id, type) =>
    new Promise((resolve, reject) =>
      dispatch(
        fundingEnquiryActions.requestUpdateFundingEnquiryStatus(id, type, { resolve, reject }),
      ),
    ),
});

export default compose(
  withModal({
    contentOnTop: true,
    secondary: false,
    modalId: 'updateEnquiryStatus',
    unmountOnClose: true,
  }),
  connect(mapStateToProps, mapDispatchToProps),
)(UpdateEnquiryStatusModal);
